<div class="modal-body">
  <p>{{ 'MODAL_EXHIBITOR_PASSWORD_RECOVERY.QUESTION' | translate }}</p>
</div>
<div class="modal-footer">
  <button type="button" (click)="close()" class="btn btn-light mx-sm-2" >{{ 'COMMON.CANCEL' | translate }}</button>
  <button type="button" (click)="setOption('yes')" class="btn btn--submit mx-sm-2" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'COMMON.YES' | translate }}</button>
</div>
